// extracted by mini-css-extract-plugin
module.exports = {"categories":"styles_categories__R2_DV","top":"styles_top__djKey","active":"styles_active__N1XFL"};